<ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
  <ziro-text fieldId="groupName"></ziro-text>
  <ziro-radio fieldId="pstnConnectivityType"></ziro-radio>
  <ziro-text fieldId="carrierName"></ziro-text>
  <ziro-radio fieldId="callingType"></ziro-radio>
  <ziro-select
    #sharedCallingRoutingPolicy
    fieldId="sharedCallingRoutingPolicy"
    (selectWasClicked)="reloadSharedCallingPolicyOptions()"
  ></ziro-select>
  <ziro-select fieldId="enforcedNumbersUsageLocation"></ziro-select>
  <ziro-text fieldId="mainNumber"></ziro-text>
  <div
    class="row mb-4"
    [hidden]="formData.callingType === CallingType.SHARED_CALLING"
    [ngbTooltip]="'tkey;admin.msdialplan.management.group.disabled.tooltip' | translate"
    [disableTooltip]="!isDisabledForAdmin"
  >
    <div class="col-6 d-flex flex-column">
      <label
        [ngClass]="{
          'ziro-forms-error': extensionRangesDisplayFormValidationState === validationStates.INVALID,
          'ziro-forms-warning': extensionRangesDisplayFormValidationState === validationStates.WARNING,
        }"
        data-automation="extension-ranges-label"
        class="ziro-forms-label col-form-label"
      >
        <span class="text-danger ziro-forms-asterisk">*</span>
        <span>
          {{ 'tkey;admin.msdialplan.management.group_list.dn_ranges' | translate }}
        </span>
      </label>
      <div class="d-flex flex-column flex-grow-1 flex-min-height-0">
        @if (displayRangeForm) {
          <ziro-extension-ranges-display-form
            data-automation="extension-ranges-display-form"
            [entity]="displayRangeFormEntity"
            [optionalValidators]="displayRangeFormOptionalValidators"
            [isRequired]="true"
            [isZpm]="true"
            [isDisabled]="isDisabledForAdmin"
            [zpmCallingType]="entity.callingType"
            (ziroFormsUpdate$)="onRangeFormUpdate($event)"
            class="d-flex flex-column h-100"
          ></ziro-extension-ranges-display-form>
        }
      </div>
    </div>
    <div class="col-6 d-flex flex-column justify-content-between">
      <ziro-textarea fieldId="bulkRanges"></ziro-textarea>
      <ziro-button
        [id]="'msDialPlanGroupGenerateBulkButton'"
        [dataAutomation]="'ms-dialplan-group-generate-ranges-button'"
        [label]="'tkey;dialplanmanagement.admin.group.generate.button'"
        [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
        (clicked)="generateBulkRangesClicked()"
        [isDisabled]="isDisabledForAdmin || validationFlags['bulkRanges'] === validationStates.INVALID"
        [tooltip]="
          isDisabledForAdmin
            ? ('tkey;admin.msdialplan.management.group.disabled.tooltip' | translate)
            : ('tkey;dialplanmanagement.admin.group.generate.button.disabled_tooltip' | translate)
        "
        [isTooltipDisabled]="!isDisabledForAdmin && validationFlags['bulkRanges'] === validationStates.VALID"
      ></ziro-button>
    </div>
  </div>
  @for (fieldId of fieldIds; track fieldId) {
    <ziro-custom-select
      [fieldId]="fieldId"
      [id]="fieldId"
      [attr.data-automation]="fieldId"
      [isServiceEnabled]="true"
    ></ziro-custom-select>
  }
  <ziro-custom-input-text
    [fieldId]="'lineUri'"
    [id]="'lineUri'"
    [attr.data-automation]="'lineUri-input'"
  ></ziro-custom-input-text>
  <ziro-text fieldId="billingLocation"></ziro-text>
</ziro-collapsible-section-card>

<div [hidden]="!isSupportUser() || !isBandwidthConfigured()">
  <ziro-collapsible-section-card
    (toggleSwitch)="onBandwidthRangeSelected($event)"
    [title]="'tkey;admin.msdialplan.management.field.bandwidth_range.label'"
    [icon]="ziroIcons.BANDWIDTH_LOGO"
    [isOpenInput]="isBandwidthGroup"
    [dataAutomation]="'bandwidth-dial-plan-group-card'"
    [switchId]="'bandwidthDialplan'"
    [isDisabled]="
      entity.callingType === CallingType.EXTENSION ||
      entity.pstnConnectivityType === PstnConnectivityType.OPERATOR_CONNECT ||
      entity.pstnConnectivityType === PstnConnectivityType.MICROSOFT_CALLING_PLANS ||
      entity.callingType === CallingType.SHARED_CALLING
    "
    [disabledTooltip]="getBandwidthCallingSettingsTooltip()"
  >
    <ziro-custom-select
      [fieldId]="'e911Geolocation'"
      [id]="'e911Geolocation'"
      [attr.data-automation]="'e911Geolocation'"
      [hidden]="false"
      [isServiceEnabled]="true"
    ></ziro-custom-select>
  </ziro-collapsible-section-card>
</div>
@if (isSyncStatusEstablished) {
  <div [hidden]="!onPremAdWriteDownEnabled() && !entity.adWriteDownList">
    <ziro-collapsible-section-card
      (toggleSwitch)="onAdAttributesToggled($event)"
      [title]="'tkey;admin.msdialplan.management.field.write_to_ad.card.label'"
      [isOpenInput]="!!entity.adWriteDownList && entity.adWriteDownList.length > 0 && isZpcSyncPresent"
      [dataAutomation]="'write-to-ad-card'"
      [switchId]="'writeToAdSwitch'"
      [isDisabled]="!isZpcSyncPresent"
      [disabledTooltip]="'tkey;admin.msdialplan.management.field.write_to_ad.card.disabled_tooltip'"
      [icon]="ziroIcons.LDAP"
    >
      @if (isZpcSyncInWarningState) {
        <div class="alert alert-warning d-flex justify-content-between">
          <span>
            <i class="{{ ziroIcons.WARNING_TRIANGLE }} me-1"></i>
            <strong
              data-automation="ad-attribute-warning-banner-text"
              [innerHTML]="'tkey;shared.model.dial_plan_management.ad_attributes.warning_banner.text' | escapeHtml"
            ></strong>
          </span>
        </div>
      }
      @if (!onPremAdWriteDownEnabled() && entity.adWriteDownList) {
        <div class="alert alert-warning d-flex justify-content-between">
          <span>
            <i class="{{ ziroIcons.WARNING_TRIANGLE }} me-1"></i>
            <strong
              data-automation="ad-write-down-disabled-warning-banner-text"
              [innerHTML]="'tkey;shared.model.dial_plan_management.ad_write_down_disabled_banner.text' | escapeHtml"
            ></strong>
          </span>
        </div>
      }
      <ziro-ad-attributes
        (adItemWasChanged)="handleAttributeUpdate()"
        [initialAdAttributes]="initialAdAttributesEntity"
        [dynamicPreviewValue]="firstNumberInRange"
      ></ziro-ad-attributes>
    </ziro-collapsible-section-card>
  </div>
}
